import { render, staticRenderFns } from "./PollinationTubesComponent.vue?vue&type=template&id=1668d114&"
import script from "./PollinationTubesComponent.vue?vue&type=script&lang=js&"
export * from "./PollinationTubesComponent.vue?vue&type=script&lang=js&"
import style0 from "./PollinationTubesComponent.vue?vue&type=style&index=0&id=1668d114&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports